import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import React from "react";
import { ArrayField, Datagrid, NumberField, ReferenceField, SimpleShowLayout, TextField } from "react-admin";
import { Box, useMediaQuery } from "@mui/material";
import { SectionTitle } from "features/SectionTitle";

const SpecialitiesArrayField = ({ showZvoCapacity = true }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <SimpleShowLayout>
      <SectionTitle
        title="Специалности"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Box sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}>
        <ArrayField
          source="specialityDtos"
          label=" "
        >
          <Datagrid
            rowClick={false}
            bulkActionButtons={false}
            sx={settings.style.secondaryDatagrid}
          >
            <ReferenceField
              source="specialityId"
              label="Специалност"
              reference={administrationRequests.getSpecialitiesSelect()}
            >
              <TextField
                label="Специалност"
                source="name"
              />
            </ReferenceField>
            <NumberField
              label="Брой места"
              source="capacityDto.candidatesCapacity"
            />
            <NumberField
              label="Брой места за мъже"
              source="capacityDto.maleCapacity"
            />
            <NumberField
              label="Брой места за жени"
              source="capacityDto.femaleCapacity"
            />
            {showZvoCapacity && (
              <NumberField
                label="Брой места за ЗВО"
                source="capacityDto.zvoCapacity"
              />
            )}
          </Datagrid>
        </ArrayField>
      </Box>
    </SimpleShowLayout>
  );
};

export default SpecialitiesArrayField;
